import { render, staticRenderFns } from "./UserLinkGroupsDialog.vue?vue&type=template&id=1d96c169&scoped=true"
import script from "./UserLinkGroupsDialog.vue?vue&type=script&lang=js"
export * from "./UserLinkGroupsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d96c169",
  null
  
)

export default component.exports